// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MachineMaintenanceReminder_card__VMYW6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 360px;
  max-width: 480px;
  text-align: center;
}

.MachineMaintenanceReminder_icon__WIVch {
  color: var(--primaryColor, #00b28d);
}

.MachineMaintenanceReminder_title__l8AL2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.4;
  color: var(--black, #212121);
}

.MachineMaintenanceReminder_subtitle__Q7zKv {
  margin: 0;
  font-size: 0.9rem;
  color: var(--black75, #474949);
}

.MachineMaintenanceReminder_actions__0LPKP {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  width: 100%;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .MachineMaintenanceReminder_card__VMYW6 {
    min-width: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/MachineMaintenanceReminder.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-width: 360px;\n  max-width: 480px;\n  text-align: center;\n}\n\n.icon {\n  color: var(--primaryColor, #00b28d);\n}\n\n.title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--black, #212121);\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--black75, #474949);\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n  .card {\n    min-width: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `MachineMaintenanceReminder_card__VMYW6`,
	"icon": `MachineMaintenanceReminder_icon__WIVch`,
	"title": `MachineMaintenanceReminder_title__l8AL2`,
	"subtitle": `MachineMaintenanceReminder_subtitle__Q7zKv`,
	"actions": `MachineMaintenanceReminder_actions__0LPKP`
};
export default ___CSS_LOADER_EXPORT___;
